import { NavigateErrorActionTypes } from "./constants";

export const navigateErrorClearAllErrors = () => ({
	type: NavigateErrorActionTypes.RESET_ALL_ERRORS,
});